// Actions
export const setProfessionals = ({ commit }, payload) => {
  commit('SET_PROFESSIONALS', payload)
}
export const addProfessionals = ({ commit }, payload) => {
  commit('ADD_PROFESSIONALS', payload)
}
export const setProfessionalsLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONALS_LOADING', payload)
}
export const setProfessionalsIsActive = ({ commit }, payload) => {
  commit('SET_PROFESSIONALS_IS_ACTIVE', payload)
}

export const setAllProfessionals = ({ commit }, payload) => {
  commit('SET_ALL_PROFESSIONALS', payload)
}
export const addAllProfessionals = ({ commit }, payload) => {
  commit('ADD_ALL_PROFESSIONALS', payload)
}
export const setAllProfessionalsLoading = ({ commit }, payload) => {
  commit('SET_ALL_PROFESSIONALS_LOADING', payload)
}
export const setAllProfessionalsIsActive = ({ commit }, payload) => {
  commit('SET_ALL_PROFESSIONALS_IS_ACTIVE', payload)
}

export const setChurn = ({ commit }, payload) => {
  commit('SET_CHURN', payload)
}
export const addChurn = ({ commit }, payload) => {
  commit('ADD_CHURN', payload)
}
export const setChurnLoading = ({ commit }, payload) => {
  commit('SET_CHURN_LOADING', payload)
}

export const setGoals = ({ commit }, payload) => {
  commit('SET_GOALS', payload)
}
export const addGoals = ({ commit }, payload) => {
  commit('ADD_GOALS', payload)
}
export const setGoalsLoading = ({ commit }, payload) => {
  commit('SET_GOALS_LOADING', payload)
}

export const setGoalsManager = ({ commit }, payload) => {
  commit('SET_GOALS_MANAGER', payload)
}
export const addGoalsManager = ({ commit }, payload) => {
  commit('ADD_GOALS_MANAGER', payload)
}
export const setGoalsManagerLoading = ({ commit }, payload) => {
  commit('SET_GOALS_MANAGER_LOADING', payload)
}

export const setStatistics = ({ commit }, payload) => {
  commit('SET_STATISTICS', payload)
}
export const addStatistics = ({ commit }, payload) => {
  commit('ADD_STATISTICS', payload)
}
export const setStatisticsLoading = ({ commit }, payload) => {
  commit('SET_STATISTICS_LOADING', payload)
}

export const setCorporatePoll = ({ commit }, payload) => {
  commit('SET_CORPORATE_POLL', payload)
}
export const addCorporatePoll = ({ commit }, payload) => {
  commit('ADD_CORPORATE_POLL', payload)
}
export const setCorporatePollLoading = ({ commit }, payload) => {
  commit('SET_CORPORATE_POLL_LOADING', payload)
}

export const setUserReturnDestination = ({ commit }, payload) => {
  commit('SET_USER_RETURN_DESTINATION', payload)
}
export const setBankDetails = ({ commit }, payload) => {
  commit('SET_BANK_DETAILS', payload)
}
export const addBankDetails = ({ commit }, payload) => {
  commit('ADD_BANK_DETAILS', payload)
}
export const setBankDetailsLoading = ({ commit }, payload) => {
  commit('SET_BANK_DETAILS_LOADING', payload)
}

